import { useEffect, useRef, useState } from "react";

type UseInViewOptions = {
  threshold?: number;
  shouldeDetect?: boolean;
};

export function useInView({
  threshold = 0.1,
  shouldeDetect = true,
}: UseInViewOptions = {}) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (typeof window.IntersectionObserver === "undefined" || !shouldeDetect) {
      setIsInView(true);
      return;
    }

    // eslint-disable-next-line compat/compat
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [threshold, shouldeDetect]);

  return { ref, isInView };
}
